<div
  class="flex flex--column spacing--margin-vertical cow-tooltip-shell"
  style="
    background: #fff;
    opacity: 1;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    padding: 10px;
    min-width: 280px;
  "
>
  @if (data()) {
    <div class="flex flex--row flex--justify-space-between flex--align-center">
      <div>
        <b>{{ localizedStrings()?.name }}:</b> {{ data().name }}
      </div>
      <div>
        <button mat-icon-button (click)="onClose()" aria-label="Close tooltip">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div>{{ localizedStrings()?.earNumber }}: {{ data().earNumber }}</div>
    <div>{{ localizedStrings()?.age }}: {{ data().age }}</div>
    <div>{{ localizedStrings()?.height }}: {{ data().height }}</div>
    @if (data().bodyConditionScore) {
      <div>{{ localizedStrings()?.bcs }}: {{ data().bodyConditionScore }}</div>
    }
    @if (showExcludeFromAverageControl()) {
      <div>
        <mat-checkbox
          color="primary"
          [checked]="data().isExcludedFromMeasurements"
          (change)="onExcludeChange($event)"
          [attr.data-registration-number]="data().registrationNumber"
        >
          {{ localizedStrings()?.excludeButton }}
        </mat-checkbox>
      </div>
    }
    @if (showIndividualMonitoringButton()) {
      <div>
        <button mat-raised-button color="primary" (click)="onViewIndividualMonitoring()">
          {{ localizedStrings()?.individualMonitoringButton }}
        </button>
      </div>
    }
  }
</div>
